// extracted by mini-css-extract-plugin
module.exports = {"loader":"PriceFilterPopup_loader__P1DtX","root":"PriceFilterPopup_root__3o0Yi","label":"PriceFilterPopup_label__3Fw7h","labelSelected":"PriceFilterPopup_labelSelected__UifSo"};